import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-setup"
export default class extends Controller {
  static targets = ["stripeConfig", "mercadopagoConfig"]

  connect() {
    this.toggleGateway()
    this.setupSelectionStyles()
  }

  toggleGateway() {
    const stripeRadio = this.element.querySelector('input[value="stripe"]')
    const mercadopagoRadio = this.element.querySelector('input[value="mercado_pago"]')

    if (stripeRadio?.checked) {
      this.showStripe()
    } else if (mercadopagoRadio?.checked) {
      this.showMercadoPago()
    }

    this.updateSelectionStyles()
  }

  showStripe() {
    if (this.hasStripeConfigTarget) {
      this.stripeConfigTarget.classList.remove('hidden')
    }
    if (this.hasMercadopagoConfigTarget) {
      this.mercadopagoConfigTarget.classList.add('hidden')
    }
  }

  showMercadoPago() {
    if (this.hasStripeConfigTarget) {
      this.stripeConfigTarget.classList.add('hidden')
    }
    if (this.hasMercadopagoConfigTarget) {
      this.mercadopagoConfigTarget.classList.remove('hidden')
    }
  }

  setupSelectionStyles() {
    // Apply initial selection styles
    this.updateSelectionStyles()
  }

  updateSelectionStyles() {
    const radios = this.element.querySelectorAll('input[name="organization[payment_gateway]"]')

    radios.forEach(radio => {
      const label = radio.closest('label')
      if (!label) return

      // Remove all selection styles first
      label.classList.remove('border-indigo-500', 'border-blue-500', 'ring-2', 'ring-indigo-500', 'ring-blue-500')
      label.classList.add('border-gray-300')

      // Add selection styles to checked radio
      if (radio.checked) {
        label.classList.remove('border-gray-300')
        if (radio.value === 'stripe') {
          label.classList.add('border-indigo-500', 'ring-2', 'ring-indigo-500')
        } else if (radio.value === 'mercado_pago') {
          label.classList.add('border-blue-500', 'ring-2', 'ring-blue-500')
        }
      }
    })
  }
}
